// import axiosClient from 'axios';
import { GET_USER_DETAIL } from '../Enums/User.Enums';
import { ADD_TOAST_MESSAGE } from '../Enums/Contracts.Globals.Enums';
import axios from '../../http.service';
// const axios = axiosClient.create();

export const getUserDetail = () => {
	return async dispatch => {
		try {
			let resp = await axios.get(`/api/v2/user`);
			if (resp.status === 200) dispatch({ type: GET_USER_DETAIL, payload: resp.data });
			else dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'error', message: 'An Error occurred when retrieving User data' } });
		} catch (err) {
			dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'error', message: err.message } });
		}
	};
};
